










import { Component, Prop } from 'vue-property-decorator';
import { PropType } from 'vue';
import IconMixin from '@/components/Helper/Icon/icon.mixin';

@Component<SvgIcon>({})
export default class SvgIcon extends IconMixin {
  @Prop({ type: Array as PropType<string[]>, required: true })
  paths: string;

  @Prop({ type: [Number, String], default: 512 })
  actualSize: number | string;
}
